import { useState } from 'react'

import { PktProgressbar } from '@/components/progressbar/Progressbar'

import { PktButton } from '..'

export default function ProgressBar() {
  const [count, setCount] = useState(50)
  const [counts, setCounts] = useState(4)
  const [percentage, setPercentage] = useState(70)
  const [fraction, setFraction] = useState(3)
  const [fractions, setFractions] = useState(4)

  const increment = (value: number, setter: (arg0: any) => void, incrementation: number) => {
    setter(value + incrementation)
  }

  const decrement = (value: number, setter: (arg0: any) => void, incrementation: number) => {
    setter(value - incrementation)
  }

  const [showAlert, setShowAlert] = useState(false)

  return (
    <main className="page-main pkt-container">
      <h1>Progressbar</h1>
      <section className="component">
        <div style={{ margin: '50px 0 15px 0' }}>
          <PktProgressbar
            className="blue-blue"
            title={'Overskrift sentrert'}
            titlePosition="center"
            valueCurrent={count}
            statusType={'percentage'}
            statusPlacement={'left'}
            ariaValueText="alternativ verditekst her!"
            id="blue-progressbar"
          />
        </div>
        <PktButton
          size={'small'}
          onClick={() => decrement(count, setCount, 1)}
          style={{ margin: '0 15px 0 0' }}
          disabled={count < 0}
        >
          -1%
        </PktButton>
        <PktButton size={'small'} onClick={() => increment(count, setCount, 1)} disabled={count > 99}>
          +1%
        </PktButton>
        <div style={{ margin: '50px 0 15px 0' }}>
          <PktProgressbar
            role={'meter'}
            id={'thisIdIsIT'}
            title={'Meter'}
            valueCurrent={counts}
            statusType={'percentage'}
            skin={'light-blue'}
          />
        </div>
        <PktButton
          size={'small'}
          onClick={() => decrement(counts, setCounts, 1)}
          style={{ margin: '0 15px 0 0' }}
          disabled={counts < 1}
          color="blue"
        >
          -1%
        </PktButton>
        <PktButton size={'small'} onClick={() => increment(counts, setCounts, 1)} disabled={counts > 99} color="blue">
          +1%
        </PktButton>
        <div style={{ margin: '50px 0 15px 0' }}>
          <PktProgressbar
            valueCurrent={fraction}
            valueMax={20}
            statusType={'fraction'}
            ariaLabel="Antall gjennomførte spørsmål"
            skin={'green'}
          />
        </div>
        <PktButton
          color="green"
          size={'small'}
          onClick={() => decrement(fraction, setFraction, 1)}
          style={{ margin: '0 15px 0 0' }}
          disabled={fraction < 1}
        >
          -1
        </PktButton>
        <PktButton
          color="green"
          size={'small'}
          onClick={() => increment(fraction, setFraction, 1)}
          style={{ margin: '0 15px 0 0' }}
          disabled={fraction > 19}
        >
          +1
        </PktButton>
        <PktButton
          color="green"
          size={'small'}
          onClick={() => decrement(fraction, setFraction, Math.min(5, fraction))}
          style={{ margin: '0 15px 0 0' }}
          disabled={fraction < 1}
        >
          -5
        </PktButton>
        <PktButton
          color="green"
          size={'small'}
          onClick={() => increment(fraction, setFraction, Math.min(5, 20 - fraction))}
          disabled={fraction > 19}
        >
          +5
        </PktButton>
        <div style={{ margin: '50px 0 15px 0' }}>
          <PktProgressbar
            id={'progressPercentage'}
            valueCurrent={percentage}
            statusType={'percentage'}
            title="Overskrift venstre"
            statusPlacement={'left'}
            skin={'red'}
          />
        </div>
        <PktButton
          color="red"
          size={'small'}
          onClick={() => decrement(percentage, setPercentage, 10)}
          style={{ margin: '0 15px 0 0' }}
          disabled={percentage < 1}
        >
          -10
        </PktButton>
        <PktButton
          color="red"
          size={'small'}
          onClick={() => increment(percentage, setPercentage, 10)}
          disabled={percentage > 90}
        >
          +10
        </PktButton>
        <div style={{ margin: '50px 0 15px 0' }}>
          <PktProgressbar
            id={'progressFractions'}
            valueCurrent={fractions}
            title={'Status senter'}
            statusPlacement={'center'}
            statusType="fraction"
            skin={'dark-blue'}
            valueMax={14}
          />
        </div>
        <PktButton
          size={'small'}
          onClick={() => decrement(fractions, setFractions, 1)}
          style={{ margin: '0 15px 0 0' }}
          disabled={fractions < 1}
        >
          -1
        </PktButton>
        <PktButton size={'small'} onClick={() => increment(fractions, setFractions, 1)} disabled={fractions > 13}>
          +1
        </PktButton>

        <br></br>
      </section>
    </main>
  )
}
